/**
 * @generated SignedSource<<711a51c42575891738c51079b8243448>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ParticipativeModuleLayout_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayParticipativeModuleStepsAfterSections",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsSubmissionAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isFullScreen",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributeButton_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Steps_steppable"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSections_page"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TitleBarWithAction_resource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Breadcrumbs_page"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "1c9b7f10385982149ebf45016c5665b9";

module.exports = node;
